import React from "react";
import { getTeamColor } from "../utils/colorUtils";

interface TeamDisplayProps {
  team: {
    id: number;
    name: string;
    colour_code?: string;
  };
  className?: string;
}

/**
 * TeamDisplay component - renders a team name with a colored square indicator
 * The color is either the team's assigned colour_code or a deterministically generated color
 */
const TeamDisplay: React.FC<TeamDisplayProps> = ({ team, className = "" }) => {
  const color = getTeamColor(team);

  return (
    <span className={`team-display ${className}`}>
      <span
        className="team-color-square"
        style={{
          backgroundColor: color,
          display: "inline-block",
          width: "14px",
          height: "14px",
          borderRadius: "2px",
          marginRight: "8px",
          verticalAlign: "middle",
          border: "1px solid var(--border-medium)",
        }}
      />
      <span className="team-name">{team.name}</span>
    </span>
  );
};

export default TeamDisplay;
